import { ReactElement } from 'react'
import { PageWrapper, TabWrapper, SectionTitle } from '../../../../components'
import Tabs from 'react-bootstrap/esm/Tabs'
import Tab from 'react-bootstrap/esm/Tab'
import strings from '../../../../locale/en'
import NewlyAddedList from './NewlyAddedTest'
import AssignedTest from './AssignedTest'

const TestListing = (): ReactElement => {
  const {
    menu: {
      admin: {
        createTest: { newlyAddedList, assignedTest, testListing }
      }
    }
  } = strings
  return (
    <PageWrapper id="container">
      <SectionTitle title={testListing} />
      <TabWrapper>
        <Tabs
          defaultActiveKey="newlyAddedList"
          id="create-test-list"
          className="mb-3"
        >
          <Tab eventKey="newlyAddedList" title={newlyAddedList}>
            <NewlyAddedList />
          </Tab>
          <Tab eventKey="assignedTest" title={assignedTest}>
            <AssignedTest />
          </Tab>
        </Tabs>
      </TabWrapper>
    </PageWrapper>
  )
}

export default TestListing
